<template>
  <component
    :is="kind == 'div' ? 'div' : 'tr'"
    v-if="item.fromEventId"
    class="alert--background-color--force"
  >
    <component
      :is="kind == 'div' ? 'div' : 'td'"
      colspan="99"
      class="text-red"
      :class="{
        'text-center': kind == 'cell'
      }"
    >
      <div class="d-flex flex-row justify-center">
        <v-icon
          v-if="kind == 'cell'"
          color="red"
          small
          class="mr-1"
          style="align-self: flex-start"
          >$iconBell</v-icon
        >
        <p class="mb-0">
          {{ $t("wallet:EventFinancesPage.prizesTab.dataMissing.badge.alert") }}

          <router-link
            :to="{
              name: 'EventRegistrationEditPage',
              params: {
                eventId: item.fromEventId,
                registrationId: item.results[0].registration.id
              }
            }"
            class="text-red bold"
            style="text-decoration: underline !important"
          >
            {{
              $t(
                "wallet:EventFinancesPage.prizesTab.dataMissing.regFormLink.text"
              )
            }}
          </router-link>
        </p>
      </div>
    </component>
  </component>
</template>
<script>
export default {
  name: "PayoutHistoryErrorRow",
  props: {
    item: {
      type: Object,
      required: true
    },
    kind: {
      type: String,
      default: "row"
    }
  }
};
</script>
